export default __webpack_public_path__ + "static/media/placeholder_store04-jp-mobile.f0d361b5.png";